// AuthContext.js
import { createContext, useContext, useEffect, useState } from 'react';
import useClientsStore from '../stores/useClientsStore';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [permissions, setPermissions] = useState([]);
    const [clientId, setClientId] = useState(null);
    const [userId, setUserId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const storedToken = sessionStorage.getItem('token');
        const storedPermissions = sessionStorage.getItem('permissions');
        const storedClientId = sessionStorage.getItem('clientId');
        const storedUserId = sessionStorage.getItem('idUser');

        if (storedToken && storedPermissions && storedClientId) {
            setUser(JSON.parse(storedToken));
            setPermissions(JSON.parse(storedPermissions));
            const parsedClientId = JSON.parse(storedClientId);
            setClientId(parsedClientId);
            if (parsedClientId === 1) {
                useClientsStore.getState().fetchClients();
            }
        }
        if (storedUserId) {
            setUserId(storedUserId);
        }
        setIsLoading(false);
    }, []);

    const login = (userData, userPermissions, clientId) => {
        setUser(userData);
        console.log(userData);
        setPermissions(userPermissions);
        setClientId(clientId);
        sessionStorage.setItem('token', JSON.stringify(userData));
        sessionStorage.setItem('permissions', JSON.stringify(userPermissions));
        sessionStorage.setItem('clientId', JSON.stringify(clientId));
        if (clientId === 1) {
            useClientsStore.getState().fetchClients();
        }
    };

    const logout = () => {
        setUser(null);
        setPermissions([]);
        setClientId(null);
        setUserId(null);
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('permissions');
        sessionStorage.removeItem('clientId');
        sessionStorage.removeItem('idUser');
        sessionStorage.removeItem('userEmail');
        useClientsStore.getState().clearClients();
    };

    return (
        <AuthContext.Provider value={{ user, permissions, clientId, userId, login, logout, isLoading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
